import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from '../../../../redux/reducers/userReducer';
import {
  evaluateAbCat,
  getAllConstants,
} from '../../../../services/apiService';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import LoadingCircleIcon from '../../../../icons/LoadingCircle';

const RejectFormModal = ({
  open,
  onClose,
  onSubmit,
  form,
  onChange,
  isEditMode,
  rowData,
  onAfterSubmit,
}) => {
  // const [decision, setDecision] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [newRemark, setNewRemark] = useState('');
  const [rejectionReasonsList, setRejectionReasonsList] = useState([]);
  const [rejectionReasonType, setRejectionReasonType] = useState('');
  const [customReason, setCustomReason] = useState('');
  const user = useSelector(userSelector);
  const [loading, setLoading] = useState(false);
  console.log(form, loading, rowData, 'sadfds');
  function processRemarksForMJML(htmlContent) {
    // Remove unnecessary escapes for > and <
    return htmlContent.replace(
      /(>)\s+|\s+(<)|\s+(?=([^"]*"[^"]*")*[^"]*$)(?![^<]*>)/g,
      function (match, afterTag, beforeTag) {
        if (afterTag) {
          return afterTag + '&nbsp;';
        } else if (beforeTag) {
          return '&nbsp;' + beforeTag;
        } else {
          // This is a space in text content, not in attributes
          return match.replace(/\s/g, '&nbsp;');
        }
      }
    );
  }

  // Alternative simpler approach - replace spaces only in text content
  // function processRemarksSimple(htmlContent) {
  //   // Split by HTML tags and process only the text parts
  //   const parts = htmlContent.split(/(<[^>]*>)/);

  //   return parts
  //     .map((part, index) => {
  //       // Even indices are text content, odd indices are HTML tags
  //       if (index % 2 === 0) {
  //         // This is text content - replace spaces with &nbsp;
  //         return part.replace(/ /g, '&nbsp;');
  //       } else {
  //         // This is an HTML tag - leave it unchanged
  //         return part;
  //       }
  //     })
  //     .join('');
  // }

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Process rejection reason for MJML (replace spaces with &nbsp;)
    const processedRemarks = processRemarksForMJML(
      form?.rejectionReasons || ''
    );

    const payload = {
      userABCATReportId: rowData?.id,
      userId: rowData?.user_id,
      languageProficiency: form.languageProficiency || null,
      technicalFluencyAudited: form.technicalFluencyAudited ? 'Yes' : 'No',
      foundCopying: form.foundCopying ? 'Yes' : 'No',
      commFluencyAudited: form.commFluencyAudited ? 'Yes' : 'No',
      ...(form.decision === 'approve'
        ? { status: 'approved' }
        : form.decision === 'reject'
        ? { status: 'rejected' }
        : {}),
      shortList:
        form.shortlisted === 'yes'
          ? true
          : form.shortlisted === 'no'
          ? false
          : undefined,
      rejectReason: processedRemarks, // Use processed remarks here
      data: {
        interviewNotes: form.internalRemarks || [],
        evaluationDate: new Date().toISOString(),
        almaXCohort: form?.almaXCohort,
      },
    };

    const response = await evaluateAbCat(payload);
    if (response) {
      onClose && onClose();
      onAfterSubmit && onAfterSubmit();
      setIsUpdate(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    // If form has existing data, set update mode
    if (isEditMode) setIsUpdate(true);
    else setIsUpdate(false);
    // Optionally, set decision based on form data
    // setDecision(form.isApproved ? 'approve' : 'reject');
  }, [isEditMode]);

  // Set rejection reason dropdown and textarea when modal opens or form changes
  useEffect(() => {
    if (!open) return;
    if (!form.rejectionReasons) {
      setRejectionReasonType('');
      setCustomReason('');
      return;
    }
    // Strip HTML tags for matching
    const stripHtml = (html) => html.replace(/<[^>]+>/g, '').trim();

    const plainTextReason = stripHtml(form.rejectionReasons);

    const match = rejectionReasonsList.find(
      (r) => stripHtml(r.Value) === plainTextReason
    );
    if (match) {
      setRejectionReasonType(String(match.id));
      setCustomReason(form.rejectionReasons); // Keep HTML for editor
    } else if (form.rejectionReasons) {
      setRejectionReasonType('other');
      setCustomReason(form.rejectionReasons);
    } else {
      setRejectionReasonType('');
      setCustomReason('');
    }
  }, [open, form.rejectionReasons, rejectionReasonsList]);

  // Initialize internal remarks as array if it doesn't exist
  useEffect(() => {
    if (!form.internalRemarks || !Array.isArray(form.internalRemarks)) {
      onChange({
        target: {
          name: 'internalRemarks',
          value: [],
        },
      });
    }
  }, []);

  useEffect(() => {
    console.log(form, 'changes');
    async function fetchConstants() {
      try {
        const res = await getAllConstants();
        setRejectionReasonsList(res?.rejectReasons || []);
      } catch (e) {
        setRejectionReasonsList([]);
      }
    }
    fetchConstants();
  }, []);

  const stripHtmlTags = (html) => html?.replace(/<[^>]+>/g, '').trim() || '';

  const addRemark = () => {
    const plainText = stripHtmlTags(newRemark);
    if (!plainText || !user) return;
    const timestamp = new Date().toLocaleString();
    const remarkEntry = {
      id: Date.now(),
      evaluator:
        user?.firstName + ' ' + user?.lastName || user.email || 'Unknown User',
      userId: user.id || '',
      remark: newRemark,
      timestamp: timestamp,
    };
    const updatedRemarks = [...(form.internalRemarks || []), remarkEntry];
    onChange({
      target: {
        name: 'internalRemarks',
        value: updatedRemarks,
      },
    });
    setNewRemark('');
  };

  const removeRemark = (remarkId) => {
    const updatedRemarks = form.internalRemarks.filter(
      (remark) => remark.id !== remarkId
    );
    onChange({
      target: {
        name: 'internalRemarks',
        value: updatedRemarks,
      },
    });
  };

  const handleModalClose = () => {
    setRejectionReasonType('');
    setCustomReason('');
    onClose && onClose();
  };

  if (!open) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.4)', padding: 8 }}>
      <div style={{ backgroundColor: 'var(--card-background, #fff)', borderRadius: 12, boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', padding: 24, width: '100%', maxWidth: 1152, border: '1px solid var(--border-light, rgba(0,0,0,0.07))', position: 'relative', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
        <h2 style={{ fontSize: 24, fontWeight: 700, color: '#B91C1C', marginBottom: 4 }}>
          Evaluate AB-CAT Attempt
        </h2>
        <p style={{ color: 'var(--text-secondary, #6B7280)', marginBottom: 24 }}>
          Please fill out the following details before approving or rejecting
          the attempt.
        </p>

        <form
          onSubmit={handleFormSubmit}
          className='space-y-6 flex-1 overflow-y-auto min-h-0'
        >
          <div className='grid grid-cols-2 gap-6'>
            {/* Left Column */}
            <div className='flex flex-col gap-4'>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, backgroundColor: 'var(--input-background, #F9FAFB)', padding: 16, borderRadius: 8, border: '1px solid var(--border-light, rgba(0,0,0,0.07))' }}>
                <span style={{ fontWeight: 600, color: 'var(--text-secondary, #6B7280)' }}>
                  Basic Details
                </span>

                <div className='flex items-center gap-4'>
                  <div>
                    <label style={{ fontWeight: 500, color: 'var(--text-muted, #9CA3AF)' }}>
                      Name:
                    </label>
                    <span style={{ color: 'var(--text-primary, #111827)', marginLeft: 8 }}>
                      {rowData?.User?.firstName +
                        ' ' +
                        rowData?.User?.lastName || 'N/A'}
                    </span>
                  </div>
                </div>

                <div className='flex items-center gap-2'>
                  <div className=''>
                    <label style={{ fontWeight: 500, color: 'var(--text-muted, #9CA3AF)' }}>
                      Attempt Date:
                    </label>
                    <span style={{ color: 'var(--text-primary, #111827)', marginLeft: 8 }}>
                      {rowData?.started_at
                        ? new Date(rowData?.started_at).toLocaleDateString(
                            'en-IN',
                            {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric',
                            }
                          )
                        : 'N/A'}
                    </span>
                  </div>
                  <div className='ml-4'>
                    {rowData?.public_access_url ? (
                      <a
                        href={rowData.public_access_url}
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{ color: 'var(--primary-main, #4F46E5)', textDecoration: 'underline' }}
                      >
                        doselect Report
                      </a>
                    ) : (
                      <span style={{ color: 'var(--text-primary, #111827)' }}>N/A</span>
                    )}
                  </div>
                </div>
              </div>

              <div className='flex flex-row gap-4 items-center'>
                <div>
                  <label style={{ display: 'block', fontSize: 18, fontWeight: 700, marginBottom: 8, color: 'var(--text-primary, #111827)' }}>
                    Shortlisted
                  </label>
                  <select
                    name='shortlisted'
                    value={form.shortlisted || ''}
                    onChange={(e) =>
                      onChange({
                        target: {
                          name: 'shortlisted',
                          value: e.target.value,
                        },
                      })
                    }
                    style={{ border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', width: 192, fontWeight: 600, backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)' }}
                  >
                    <option value=''>Select</option>
                    <option value='no'>No</option>
                    <option value='yes'>Yes</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 18, fontWeight: 700, marginBottom: 8, color: 'var(--text-primary, #111827)' }}>
                    Language Proficiency
                  </label>
                  <select
                    name='languageProficiency'
                    value={form.languageProficiency || ''}
                    onChange={onChange}
                    style={{ border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', width: 192, fontWeight: 600, backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)' }}
                  >
                    <option value=''>Select Proficiency</option>
                    <option value='Basic'>Basic</option>
                    <option value='Beginner'>Beginner</option>
                    <option value='Intermediate'>Intermediate</option>
                    <option value='Proficient'>Proficient</option>
                  </select>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='flex flex-row gap-4 items-center'>
                  <div>
                    <label style={{ display: 'block', fontSize: 18, fontWeight: 700, marginBottom: 8, color: 'var(--text-primary, #111827)' }}>
                      Decision
                    </label>
                    <select
                      name='decision'
                      value={form.decision}
                      onChange={onChange}
                      style={{ border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', width: 192, fontWeight: 600, backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)' }}
                    >
                      {form.shortlisted === 'yes' ? (
                        <>
                          <option value=''>Select Decision</option>
                          <option value='approve'>Approve</option>
                          <option value='reject'>Reject</option>
                        </>
                      ) : (
                        <>
                          <option value=''>Select Decision</option>
                          <option value='reject'>Reject</option>
                        </>
                      )}
                    </select>
                  </div>
                  <div className='mt-2'>
                    <label style={{ display: 'block', fontSize: 14, fontWeight: 600, marginBottom: 4, color: form.decision === 'approve' ? '#15803D' : 'var(--text-secondary, #6B7280)' }}>
                      AlmaX Cohort
                      {form.decision === 'approve' && (
                        <span style={{ color: '#EF4444' }}> *</span>
                      )}
                    </label>
                    <input
                      type='text'
                      name='almaXCohort'
                      value={form.almaXCohort}
                      onChange={onChange}
                      style={{
                        width: 192, borderRadius: 4, padding: '8px 12px',
                        border: form.decision === 'approve' ? '2px solid #4ADE80' : '1px solid var(--border-main, #D1D5DB)',
                        backgroundColor: form.decision === 'approve' ? '#F0FDF4' : 'var(--input-background, #F3F4F6)',
                        color: 'var(--text-primary, #111827)',
                      }}
                      placeholder='Enter cohort name'
                      required={form.decision === 'approve'}
                      disabled={form.decision === 'reject' || !form.decision}
                    />
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, backgroundColor: 'var(--input-background, #F9FAFB)', padding: 16, borderRadius: 8, border: '1px solid var(--border-light, rgba(0,0,0,0.07))' }}>
                <span style={{ fontWeight: 600, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}>
                  Audit Flags
                </span>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary, #6B7280)' }}>
                  <input type='checkbox' name='technicalFluencyAudited' checked={form.technicalFluencyAudited} onChange={onChange} style={{ accentColor: 'var(--primary-main, #4F46E5)', width: 20, height: 20 }} />
                  Technical Fluency Audited
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary, #6B7280)' }}>
                  <input type='checkbox' name='commFluencyAudited' checked={form.commFluencyAudited} onChange={onChange} style={{ accentColor: 'var(--primary-main, #4F46E5)', width: 20, height: 20 }} />
                  Communication Fluency Audited
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary, #6B7280)' }}>
                  <input type='checkbox' name='foundCopying' checked={form.foundCopying} onChange={onChange} style={{ accentColor: 'var(--primary-main, #4F46E5)', width: 20, height: 20 }} />
                  Found Copying
                </label>
              </div>
            </div>
            <div className='flex flex-col gap-4'>
              <div>
                <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}>
                  Internal Remarks
                </label>
                {form.internalRemarks && form.internalRemarks.length > 0 && (
                  <div
                    style={{
                      marginBottom: 4, border: '1px solid var(--border-light, rgba(0,0,0,0.07))', borderRadius: 4, padding: 0,
                      backgroundColor: 'var(--input-background, #F9FAFB)',
                      ...(form.internalRemarks.length > 2 ? { maxHeight: 128, overflowY: 'auto' } : {}),
                    }}
                  >
                    {form.internalRemarks.slice(0, 2).map((remark) => (
                      <div
                        key={remark.id}
                        style={{ marginBottom: 8, padding: 8, backgroundColor: 'var(--card-background, #fff)', borderRadius: 4, borderLeft: '4px solid var(--primary-main, #4F46E5)' }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
                          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--primary-main, #4F46E5)' }}>
                            {remark.evaluator}
                          </span>
                          <span style={{ fontSize: 12, color: 'var(--text-muted, #9CA3AF)' }}>
                            {remark.timestamp}
                          </span>
                        </div>
                        <div
                          style={{ fontSize: 12, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}
                          dangerouslySetInnerHTML={{ __html: remark.remark }}
                        />
                        <button
                          type='button'
                          onClick={() => removeRemark(remark.id)}
                          style={{ fontSize: 12, color: '#EF4444', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                    {form.internalRemarks.length > 2 && (
                      <div style={{ borderTop: '1px solid var(--border-light, rgba(0,0,0,0.07))' }}>
                        {form.internalRemarks.slice(2).map((remark) => (
                          <div
                            key={remark.id}
                            style={{ marginBottom: 8, padding: 8, backgroundColor: 'var(--card-background, #fff)', borderRadius: 4, borderLeft: '4px solid var(--primary-main, #4F46E5)' }}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
                              <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--primary-main, #4F46E5)' }}>
                                {remark.evaluator}
                              </span>
                              <span style={{ fontSize: 12, color: 'var(--text-muted, #9CA3AF)' }}>
                                {remark.timestamp}
                              </span>
                            </div>
                            <div
                              style={{ fontSize: 12, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}
                              dangerouslySetInnerHTML={{ __html: remark.remark }}
                            />
                            <button
                              type='button'
                              onClick={() => removeRemark(remark.id)}
                              style={{ fontSize: 12, color: '#EF4444', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                <div className='space-y-2'>
                  <ReactQuill
                    theme='snow'
                    value={newRemark}
                    onChange={(value) => setNewRemark(value)}
                    placeholder='Add new internal remark...'
                    style={{
                      height: '150px',
                      overflowY: 'auto',
                      background: 'var(--input-background, #fff)',
                      borderRadius: '8px',
                      color: 'var(--text-primary)',
                    }}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ color: [] }, { background: [] }],
                        ['link'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        ['clean'],
                      ],
                    }}
                  />
                  <div className='flex justify-end'>
                    <button
                      type='button'
                      onClick={addRemark}
                      disabled={!stripHtmlTags(newRemark)}
                      style={{
                        padding: '4px 12px', borderRadius: 4, fontSize: 14, fontWeight: 600, border: 'none', cursor: 'pointer',
                        backgroundColor: !stripHtmlTags(newRemark) ? 'var(--border-light, #D1D5DB)' : 'var(--primary-main, #4F46E5)',
                        color: !stripHtmlTags(newRemark) ? 'var(--text-muted, #9CA3AF)' : '#fff',
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}>
                  Rejection Reasons (external)
                </label>
                <select
                  name='rejectionReasonsDropdown'
                  value={rejectionReasonType}
                  onChange={(e) => {
                    setRejectionReasonType(e.target.value);
                    if (e.target.value === 'other' || e.target.value === '') {
                      onChange({
                        target: { name: 'rejectionReasons', value: '' },
                      });
                      setCustomReason('');
                    } else {
                      const selected = rejectionReasonsList.find(
                        (r) => r.id === Number(e.target.value)
                      );
                      const value = selected ? selected.Value : '';
                      setCustomReason(value);
                      onChange({ target: { name: 'rejectionReasons', value } });
                    }
                  }}
                  style={{ width: '100%', border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)' }}
                >
                  <option value=''>Select a reason</option>
                  {rejectionReasonsList?.map((reason) => (
                    <option key={reason.id} value={reason.id}>
                      {reason.Name}
                    </option>
                  ))}
                  <option value='other'>Other</option>
                </select>
                <ReactQuill
                  theme='snow'
                  value={customReason}
                  onChange={(value) => {
                    setCustomReason(value);
                    onChange({
                      target: {
                        name: 'rejectionReasons',
                        value: value,
                      },
                    });
                  }}
                  style={{ marginTop: 8, height: '180px', overflowY: 'auto', background: 'var(--input-background, #fff)', borderRadius: '8px', color: 'var(--text-primary)' }}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, false] }],
                      ['bold', 'italic', 'underline', 'strike'],
                      [{ color: [] }, { background: [] }],
                      ['link'],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['clean'],
                    ],
                  }}
                />
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16, marginTop: 24, borderTop: '1px solid var(--border-light, rgba(0,0,0,0.07))', paddingTop: 24, position: 'sticky', bottom: 0, backgroundColor: 'var(--card-background, #fff)', zIndex: 10 }}>
            <button
              type='button'
              style={{ padding: '8px 24px', borderRadius: 8, backgroundColor: 'var(--border-light, #E5E7EB)', color: 'var(--text-secondary, #6B7280)', fontWeight: 600, border: 'none', cursor: 'pointer' }}
              onClick={handleModalClose}
            >
              Cancel
            </button>
            <button
              type='submit'
              disabled={loading}
              style={{
                padding: '8px 24px', borderRadius: 8, backgroundColor: 'var(--primary-main, #4F46E5)', color: '#fff', fontWeight: 700, border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1,
              }}
            >
              {loading ? (
                <LoadingCircleIcon iconStyle='w-5 mr-2 animate-spin' />
              ) : rowData?.abCatEvaluation || isUpdate ? (
                'Update'
              ) : (
                'Save'
              )}
            </button>
          </div>
        </form>
        <button
          onClick={handleModalClose}
          style={{ position: 'absolute', top: 12, right: 12, color: 'var(--text-muted, #9CA3AF)', fontSize: 28, fontWeight: 700, background: 'none', border: 'none', cursor: 'pointer', lineHeight: 1 }}
          aria-label='Close'
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default RejectFormModal;
